import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPipeline = (props) => /* @__PURE__ */ _jsx("svg", {
	name: "pipeline",
	viewBox: "0 0 654 300",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "center-header",
				d: "M220.754 0h200.57c.644 0 1.233.364 1.521.94l12.774 25.52c.24.48.24 1.044 0 1.524l-12.774 25.52c-.288.577-.877.94-1.521.94h-200.57a1.701 1.701 0 0 1-1.521-2.462l12.01-23.998c.24-.48.24-1.044 0-1.523l-12.01-23.998A1.701 1.701 0 0 1 220.754 0z",
				fill: "#FFF",
				opacity: .4
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "card-background",
				fill: "#FFF",
				opacity: .4,
				x: 218,
				y: 61.389,
				width: 204.375,
				height: 54.444,
				rx: 3.403
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "card-background",
				fill: "#FFF",
				opacity: .4,
				x: 218,
				y: 122.778,
				width: 204.375,
				height: 54.444,
				rx: 3.403
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "card-background",
				fill: "#FFF",
				opacity: .4,
				x: 218,
				y: 184.167,
				width: 204.375,
				height: 54.444,
				rx: 3.403
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "card-background",
				fill: "#FFF",
				opacity: .4,
				x: 218.556,
				y: 245,
				width: 204.375,
				height: 54.444,
				rx: 3.403
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "lead-card",
				transform: "translate(224.813 68.194)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						width: 190.75,
						height: 40.833,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#9a92d9",
						x: 6.813,
						y: 20.417,
						width: 40.875,
						height: 13.611,
						rx: 1.701
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "pipeline-only",
						fill: "#FFC900",
						x: 6.813,
						y: 20.417,
						width: 40.875,
						height: 13.611,
						rx: 1.701
					})
				]
			}),
			/* @__PURE__ */ _jsx("g", {
				className: "automations",
				transform: "translate(232 78), scale(0.9)",
				children: /* @__PURE__ */ _jsxs("g", {
					fill: "#5649BE",
					children: [/* @__PURE__ */ _jsx("path", { d: "M11.986 11.986c1.453 0 2.693-.509 3.72-1.526 1.029-1.017 1.543-2.245 1.543-3.682 0-1.438-.514-2.665-1.542-3.683-1.028-1.017-2.269-1.525-3.721-1.525-1.453 0-2.694.508-3.721 1.525C7.237 4.113 6.723 5.34 6.723 6.778c0 1.437.514 2.665 1.542 3.682s2.268 1.526 3.72 1.526z" }), /* @__PURE__ */ _jsx("path", { d: "M21.394 16.007a11.387 11.387 0 0 0-.363-1.472 6.933 6.933 0 0 0-.59-1.322 4.77 4.77 0 0 0-.85-1.099 3.581 3.581 0 0 0-1.171-.725 4.157 4.157 0 0 0-1.528-.271c-.083 0-.275.097-.576.291-.302.195-.642.412-1.021.651-.38.24-.873.457-1.48.651a5.972 5.972 0 0 1-1.83.292 5.972 5.972 0 0 1-1.83-.292c-.607-.194-1.1-.411-1.48-.65-.379-.24-.72-.457-1.02-.652-.302-.194-.494-.291-.576-.291-.558 0-1.067.09-1.528.27-.462.182-.852.424-1.172.726-.32.303-.603.67-.85 1.1-.247.429-.443.87-.59 1.321-.145.452-.266.943-.362 1.472-.096.529-.16 1.022-.192 1.478a20.11 20.11 0 0 0-.048 1.404c0 1.085.333 1.942 1 2.57.667.629 1.554.943 2.66.943h11.978c1.105 0 1.992-.314 2.659-.943.667-.628 1-1.485 1-2.57 0-.48-.016-.947-.048-1.404-.032-.456-.096-.949-.192-1.478z" })]
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "automations",
				transform: "translate(216 -15)",
				children: [/* @__PURE__ */ _jsx("path", { d: "M15 153h23.971v23.971H15z" }), /* @__PURE__ */ _jsx("path", {
					d: "M36.64 159.509a1.096 1.096 0 0 0-.816-.346h-3.458v-1.186c0-.544-.188-1.01-.564-1.396a1.824 1.824 0 0 0-1.356-.581H23.53c-.528 0-.98.194-1.357.58a1.931 1.931 0 0 0-.564 1.397v1.186h-3.458c-.32 0-.592.115-.816.346-.224.23-.336.51-.336.84v1.581c0 .585.166 1.174.498 1.767.332.593.78 1.129 1.345 1.606.564.478 1.256.88 2.077 1.205.82.325 1.682.509 2.587.55a6.5 6.5 0 0 0 1.14 1.173c.304.28.514.579.63.896.116.317.174.686.174 1.106 0 .445-.122.82-.366 1.124-.244.305-.634.457-1.17.457-.6 0-1.135.188-1.603.563-.468.375-.702.846-.702 1.414v.791c0 .115.036.21.108.284a.368.368 0 0 0 .276.111h9.988a.368.368 0 0 0 .276-.11.391.391 0 0 0 .108-.285v-.79c0-.569-.234-1.04-.702-1.415a2.495 2.495 0 0 0-1.603-.563c-.536 0-.926-.152-1.17-.457-.244-.304-.366-.68-.366-1.124 0-.42.058-.789.174-1.106.116-.317.326-.615.63-.896a6.499 6.499 0 0 0 1.14-1.173 7.945 7.945 0 0 0 2.588-.55c.82-.325 1.512-.727 2.076-1.205a5.847 5.847 0 0 0 1.345-1.606c.332-.593.498-1.182.498-1.767v-1.581c0-.33-.112-.61-.336-.84zm-16.969 4.423c-.756-.692-1.134-1.36-1.134-2.002v-1.186h3.073c0 1.722.296 3.25.888 4.584-1.128-.239-2.07-.704-2.827-1.396zm15.769-2.002c0 .643-.378 1.31-1.135 2.002-.756.692-1.699 1.157-2.827 1.396.592-1.334.888-2.862.888-4.584h3.074v1.186z",
					fill: "#5649BE"
				})]
			}),
			/* @__PURE__ */ _jsx("g", {
				className: "automations",
				transform: "translate(232 200)",
				children: /* @__PURE__ */ _jsx("g", {
					fill: "#5649BE",
					children: /* @__PURE__ */ _jsx("path", { d: "M4.5 10.334H2.357a.335.335 0 0 0-.251.112.372.372 0 0 0-.106.265v2.26c0 .101.035.19.106.264.07.074.154.112.251.112H4.5c.097 0 .18-.037.251-.112a.372.372 0 0 0 .106-.265v-2.26a.372.372 0 0 0-.106-.264.335.335 0 0 0-.251-.112zM4.5 14.853H2.357a.335.335 0 0 0-.251.112.372.372 0 0 0-.106.265v2.26c0 .101.035.19.106.264.07.075.154.112.251.112H4.5c.097 0 .18-.037.251-.112a.372.372 0 0 0 .106-.265v-2.26a.372.372 0 0 0-.106-.264.335.335 0 0 0-.251-.112zM4.5 5.815H2.357a.335.335 0 0 0-.251.112.372.372 0 0 0-.106.265v2.26c0 .101.035.19.106.264.07.075.154.112.251.112H4.5c.097 0 .18-.037.251-.112a.372.372 0 0 0 .106-.265v-2.26a.372.372 0 0 0-.106-.264.335.335 0 0 0-.251-.112zM21.643 14.853h-15a.335.335 0 0 0-.251.112.372.372 0 0 0-.106.265v2.26c0 .101.035.19.106.264.07.075.154.112.25.112h15c.098 0 .181-.037.252-.112A.372.372 0 0 0 22 17.49v-2.26a.372.372 0 0 0-.106-.264.336.336 0 0 0-.251-.112zM21.894 5.927a.336.336 0 0 0-.251-.112h-15a.335.335 0 0 0-.251.112.372.372 0 0 0-.106.265v2.26c0 .101.035.19.106.264.07.075.154.112.25.112h15c.098 0 .181-.037.252-.112A.372.372 0 0 0 22 8.451v-2.26a.372.372 0 0 0-.106-.264zM21.643 10.334h-15a.335.335 0 0 0-.251.112.372.372 0 0 0-.106.265v2.26c0 .101.035.19.106.264.07.074.154.112.25.112h15c.098 0 .181-.037.252-.112A.372.372 0 0 0 22 12.97v-2.26a.373.373 0 0 0-.106-.264.335.335 0 0 0-.251-.112z" })
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "automations",
				transform: "translate(217 -27)",
				children: [/* @__PURE__ */ _jsx("path", { d: "M15 287h23.971v23.971H15z" }), /* @__PURE__ */ _jsxs("g", {
					fill: "#5649BE",
					children: [/* @__PURE__ */ _jsx("path", { d: "M18.92 295.858c.253.186 1.015.739 2.288 1.658 1.272.92 2.247 1.628 2.924 2.124.074.054.232.173.474.355.242.182.443.33.602.442.16.113.354.239.58.379.228.14.442.244.643.314.2.07.387.104.558.104h.022c.171 0 .357-.034.558-.104.201-.07.415-.175.642-.314.227-.14.42-.266.58-.379.16-.112.361-.26.603-.442l.474-.355 5.224-3.783a5.427 5.427 0 0 0 1.361-1.431c.365-.559.547-1.145.547-1.758 0-.512-.177-.95-.53-1.315-.354-.365-.772-.547-1.256-.547H18.786c-.573 0-1.014.202-1.323.605-.309.404-.463.908-.463 1.513 0 .49.205 1.019.614 1.59.409.57.844 1.018 1.306 1.344z" }), /* @__PURE__ */ _jsx("path", { d: "M35.884 297.103c-2.44 1.722-4.293 3.06-5.558 4.015-.424.326-.768.58-1.032.763a6.277 6.277 0 0 1-1.055.558c-.439.19-.848.285-1.228.285h-.022c-.38 0-.789-.095-1.228-.285a6.282 6.282 0 0 1-1.055-.558 26.274 26.274 0 0 1-1.032-.763c-1.004-.768-2.853-2.106-5.547-4.015A5.994 5.994 0 0 1 17 296.09v9.241c0 .513.175.951.525 1.316.35.365.77.547 1.26.547h16.43c.49 0 .91-.182 1.26-.547.35-.365.525-.803.525-1.316v-9.24c-.32.372-.692.71-1.116 1.012z" })]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "welcome-and-pipeline-only",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M2.754 0h200.57c.644 0 1.233.364 1.521.94l12.774 25.52c.24.48.24 1.044 0 1.524l-12.774 25.52c-.288.577-.877.94-1.521.94H2.754a1.701 1.701 0 0 1-1.521-2.462l12.01-23.998c.24-.48.24-1.044 0-1.523L1.234 2.463A1.701 1.701 0 0 1 2.754 0z",
						fill: "#FFF",
						opacity: .4
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						y: 61.389,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						y: 122.778,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						y: 184.167,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						y: 245,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M438.754 0h200.57c.644 0 1.233.364 1.521.94l12.774 25.52c.24.48.24 1.044 0 1.524l-12.774 25.52c-.288.577-.877.94-1.521.94h-200.57a1.701 1.701 0 0 1-1.521-2.462l12.01-23.998c.24-.48.24-1.044 0-1.523l-12.01-23.998A1.701 1.701 0 0 1 438.754 0z",
						fill: "#FFF",
						opacity: .4
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						x: 436,
						y: 61.389,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						x: 436,
						y: 122.778,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						x: 436,
						y: 184.167,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						opacity: .4,
						x: 435.444,
						y: 245,
						width: 204.375,
						height: 54.444,
						rx: 3.403
					}),
					/* @__PURE__ */ _jsxs("g", {
						className: "lead-card",
						transform: "translate(6.813 68.194)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								fill: "#FFF",
								width: 190.75,
								height: 40.833,
								rx: 3.403
							}),
							/* @__PURE__ */ _jsx("rect", {
								fill: "#9a92d9",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "pipeline-only",
								fill: "#1FB790",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						className: "lead-card",
						transform: "translate(6.813 129.583)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								fill: "#FFF",
								width: 190.75,
								height: 40.833,
								rx: 3.403
							}),
							/* @__PURE__ */ _jsx("rect", {
								fill: "#9a92d9",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "pipeline-only",
								fill: "#FFC900",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						className: "lead-card",
						transform: "translate(442.813 68.194)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								fill: "#FFF",
								width: 190.75,
								height: 40.833,
								rx: 3.403
							}),
							/* @__PURE__ */ _jsx("rect", {
								fill: "#9a92d9",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "pipeline-only",
								fill: "#1FB790",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						className: "lead-card",
						transform: "translate(442.813 129.583)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								fill: "#FFF",
								width: 190.75,
								height: 40.833,
								rx: 3.403
							}),
							/* @__PURE__ */ _jsx("rect", {
								fill: "#9a92d9",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "pipeline-only",
								fill: "#FA4A62",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						className: "lead-card",
						transform: "translate(442.813 190.972)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								fill: "#FFF",
								width: 190.75,
								height: 40.833,
								rx: 3.403
							}),
							/* @__PURE__ */ _jsx("rect", {
								fill: "#9a92d9",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							}),
							/* @__PURE__ */ _jsx("rect", {
								className: "pipeline-only",
								fill: "#1FB790",
								x: 6.813,
								y: 20.417,
								width: 40.875,
								height: 13.611,
								rx: 1.701
							})
						]
					})
				]
			})
		]
	})
});
export default SvgPipeline;
